import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function Products({view, products }) {
    const ProductView = ComponentRegistry.get(view);

    return (
        <section className="widget widget-products group">{Object.values(products).map(
            (product, index) => <ProductView key={index} {...product} />,
        )}</section>
    );
}

Products.propTypes = {
    view: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Products.propsTypes = {
    view: "ProductBrowserViewsThumbView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductList/Views/ProductsView.jsx